<template>
  <b-tab>
    <template #title>
      <span>Módulos</span>
      <b-badge variant="dark" class="ml-2">{{ numModulos }}</b-badge>
    </template>
    <campo-plan :disabled="ofertaBloqueada || !oferta.divisaId" />

    <!-- Cuota: Forma Pago y Descuento -->
    <b-row class="mb-4">
      <b-col lg="6">
        <campo-forma-pago :disabled="!oferta.divisaId" />
      </b-col>
      <b-col lg="6">
        <campo-descuento
          label="Descuento cuota"
          :tipos-descuento="tiposDescuentoparaCuota"
          v-model="oferta.tipoDescuentoCuotaAnual"
          :disabled="!oferta.divisaId"
        />
      </b-col>
    </b-row>

    <selector-modulos v-show="borrador" :disabled="ofertaBloqueada || !oferta.divisaId || !oferta.planId" />
    <tabla-modulos-oferta :disabled="ofertaBloqueada || !oferta.divisaId || !oferta.planId" />
    <detalle-valoracion-modulos />
  </b-tab>
</template>

<script>
import { mapState } from "pinia";
import { useSessionStore } from "@/stores/SessionStore";
import { useOfertaFormStore } from "@/stores/OfertaFormStore";

import TablaModulosOferta from "./EditorModulos/TablaModulosOferta";
import CampoPlan from "./CamposOferta/CampoPlan";
import SelectorModulos from "./EditorModulos/SelectorModulos";
import DetalleValoracionModulos from "./DetalleValoracionModulos";
import CampoFormaPago from "./CamposOferta/CampoFormaPago";
import CampoDescuento from "./CamposOferta/CampoDescuento";

export default {
  components: {
    CampoPlan,
    CampoDescuento,
    CampoFormaPago,
    SelectorModulos,
    TablaModulosOferta,
    DetalleValoracionModulos,
  },
  computed: {
    ...mapState(useSessionStore, ["esKantan"]),
    ...mapState(useOfertaFormStore, [
      "borrador",
      "cliente",
      "esNuevaVersion",
      "numModulos",
      "oferta",
      "tiposDescuentoparaCuota",
    ]),
    ofertaBloqueada() {
      return this.oferta.caducada == 1 || this.oferta.borrador == 0;
    },
  },
};
</script>
